import { ObjectTypes } from '@fi-shared/types';
import { getObjectTypeNameTextId } from '@fi-shared/utils';
import { IBalooSectionLogItem } from '@fi-app/external-platform-integration/baloo/baloo';

export enum BalooSyncTabIndex {
    Unit,
    Role,
    User,
}

export enum SyncSectionLabelColorClass {
    Green = 'green-status-color',
    Orange = 'orange-status-color',
    Red = 'red-status-color',
}

export const UnitRoleLogSummaryItems: IBalooSectionLogItem[] = [
    {
        propertyName: 'AddedToBalooCount',
        textId: 'baloo.n_items_added_as_groups',
        getItemGroupTextId: (count: number, objectType: ObjectTypes): string =>
            getObjectTypeNameTextId(objectType, count !== 1),
        labelColorClass: SyncSectionLabelColorClass.Green,
    },
    {
        propertyName: 'UpdatedCount',
        textId: 'baloo.n_items_updated',
        getItemGroupTextId: (count: number, objectType: ObjectTypes): string =>
            objectType === ObjectTypes.BusinessUnit ? 'baloo.unit_groups' : 'baloo.role_groups',
        labelColorClass: SyncSectionLabelColorClass.Green,
    },
    {
        propertyName: 'ActivatedCount',
        textId: 'baloo.n_items_reactivated',
        getItemGroupTextId: (count: number, objectType: ObjectTypes): string =>
            objectType === ObjectTypes.BusinessUnit ? 'baloo.unit_groups' : 'baloo.role_groups',
        labelColorClass: SyncSectionLabelColorClass.Green,
    },
    {
        propertyName: 'DeactivatedCount',
        textId: 'baloo.n_items_deactivated',
        getItemGroupTextId: (count: number, objectType: ObjectTypes): string =>
            objectType === ObjectTypes.BusinessUnit ? 'baloo.unit_groups' : 'baloo.role_groups',
        labelColorClass: SyncSectionLabelColorClass.Orange,
    },
    {
        propertyName: 'FailedCount',
        textId: 'baloo.n_items_failed',
        getItemGroupTextId: (count: number, objectType: ObjectTypes): string =>
            getObjectTypeNameTextId(objectType, count !== 1),
        labelColorClass: SyncSectionLabelColorClass.Red,
    },
];

export const UserLogSummaryItems: IBalooSectionLogItem[] = [
    {
        propertyName: 'AddedToBalooCount',
        textId: 'baloo.n_items_added_to_baloo',
        getItemGroupTextId: (count: number, objectType: ObjectTypes): string =>
            count !== 1 ? 'common.users' : 'user.user',
        labelColorClass: SyncSectionLabelColorClass.Green,
    },
    {
        propertyName: 'AddedToGroupCount',
        textId: 'baloo.n_items_added_to_groups_on_baloo',
        getItemGroupTextId: (count: number, objectType: ObjectTypes): string =>
            count !== 1 ? 'common.users' : 'user.user',
        labelColorClass: SyncSectionLabelColorClass.Green,
    },
    {
        propertyName: 'ActivatedCount',
        textId: 'baloo.n_items_reactivated',
        getItemGroupTextId: (count: number, objectType: ObjectTypes): string =>
            count !== 1 ? 'common.users' : 'user.user',
        labelColorClass: SyncSectionLabelColorClass.Green,
    },
    {
        propertyName: 'UpdatedCount',
        textId: 'baloo.n_items_updated',
        getItemGroupTextId: (count: number, objectType: ObjectTypes): string =>
            count !== 1 ? 'common.users' : 'user.user',
        labelColorClass: SyncSectionLabelColorClass.Green,
    },
    {
        propertyName: 'RemovedFromGroupCount',
        textId: 'baloo.n_items_removed_from_groups_on_baloo',
        getItemGroupTextId: (count: number, objectType: ObjectTypes): string =>
            count !== 1 ? 'common.users' : 'user.user',
        labelColorClass: SyncSectionLabelColorClass.Orange,
    },
    {
        propertyName: 'DeactivatedCount',
        textId: 'baloo.n_items_deactivated',
        getItemGroupTextId: (count: number, objectType: ObjectTypes): string =>
            count !== 1 ? 'common.users' : 'user.user',
        labelColorClass: SyncSectionLabelColorClass.Orange,
    },
    {
        propertyName: 'FailedCount',
        textId: 'baloo.n_items_failed',
        getItemGroupTextId: (count: number, objectType: ObjectTypes): string =>
            count !== 1 ? 'common.users' : 'user.user',
        labelColorClass: SyncSectionLabelColorClass.Red,
    },
];
